import { RequestService } from '../../../../../common/services/RequestService';
import { API_DADATA_BANK_POST } from '../../../api/constants';

export const autoSearchRequestBank = payload => {
  return RequestService.get(API_DADATA_BANK_POST + payload).then(
    response => response
  );
};
